import clsx from 'clsx'
import React from 'react'

import './Switch.scss'

const Switch = ({ className, name, checked, onChange }) => {
   return (
      <div className={clsx('Switch', className)}>
         <input
            type="checkbox"
            className="Switch__checkbox"
            name={name}
            id={name}
            checked={checked}
            onChange={onChange}
         />
         <label
            className={clsx(
               'Switch__label',
               checked && 'Switch__label--checked'
            )}
            htmlFor={name}
         >
            <span
               className={clsx(
                  'Switch__label-inner',
                  checked && 'Switch__label-inner--checked'
               )}
            />
         </label>
      </div>
   )
}

export default Switch
